import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 72px 32px;\n  overflow: hidden;\n\n  > div {\n    //height: 100%;\n    //margin: 72px 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background-color: rgba(28, 31, 46, 0.5);\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  height: 80vh;\n  max-width: 788px;\n  display: flex;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  padding: 16px;\n  display: flex;\n  gap: 16px;\n\n  .ant-col {\n    gap: 8px;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      text-overflow: ellipsis;\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 1.5;\n      letter-spacing: -0.16px;\n\n      &.price {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 24px 16px;\n  flex-direction: column;\n  padding-bottom: 80px;\n  flex-grow: 1;\n  overflow-y: auto;\n\n  > p {\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 16px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n\n  .ant-btn {\n    padding: 12px 20px;\n    font-size: 16px;\n  }\n\n  @media (max-width: 1200px) {\n    .ant-btn {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  &.ant-divider {\n    border-block-start: 8px solid ",
        ";\n  }\n\n  &.ant-divider-horizontal {\n    margin: 0;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import Sheet from "react-modal-sheet";
import { Col, Divider } from "antd";
import { ThumbnailImage } from "./RelatedListItem";
import FilledButton from "@/components/common/Button/FilledButton";
import { numberFormatter } from "@/lib/utils";
import { useRouter } from "next/router";
import Modal from "@/components/modal/Modal";
import { PRODUCTS_PAGE } from "@/settings/constant";
import useHandoutProductStore from "src/store/relatedProduct";
import Image from "@/components/common/Image";
export const RelatedProductPreviewModal = (param)=>{
    let {} = param;
    const { isMobile  } = useWindowDimensions();
    const { isOpen , onClose , product  } = useHandoutProductStore((state)=>({
            isOpen: state.isOpenRelatedProductPreviewModal,
            onClose: state.closeRelatedProductPreviewModal,
            product: state.selectedPreviewProduct
        }));
    if (!isMobile) return /*#__PURE__*/ _jsx(PassInfoModalWrapper, {
        open: isOpen,
        onClose: onClose,
        depth: 1007,
        children: /*#__PURE__*/ _jsx(PreviewRelatedItem, {
            product: product,
            onCancel: onClose
        })
    });
    return /*#__PURE__*/ _jsx(PassInfoSheet, {
        isOpen: isOpen,
        onClose: onClose,
        disableDrag: true,
        children: /*#__PURE__*/ _jsx(Sheet.Container, {
            children: /*#__PURE__*/ _jsx(Sheet.Content, {
                children: /*#__PURE__*/ _jsx(PreviewRelatedItem, {
                    product: product,
                    onCancel: onClose
                })
            })
        })
    });
};
const PassInfoModalWrapper = styled(Modal).withConfig({
    componentId: "sc-f1a9a530-0"
})(_templateObject());
const PassInfoSheet = styled(Sheet).withConfig({
    componentId: "sc-f1a9a530-1"
})(_templateObject1(), (props)=>!props.isOpen && "background-color: transparent;");
export const thumbWidth = 56;
const PreviewRelatedItem = (param)=>{
    let { product , onCancel  } = param;
    const router = useRouter();
    if (!product) return null;
    return /*#__PURE__*/ _jsxs(PreviewRelatedItemContainer, {
        children: [
            /*#__PURE__*/ _jsxs(ProductContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        children: /*#__PURE__*/ _jsx(ThumbnailImage, {
                            alt: "book-img",
                            width: thumbWidth,
                            height: 62,
                            src: product.thumbImg
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Col, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "title",
                                children: product.title
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "price",
                                children: [
                                    numberFormatter(product.price),
                                    "원"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StyledDivider, {}),
            /*#__PURE__*/ _jsxs(ImageContainer, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "미리보기"
                    }),
                    (product === null || product === void 0 ? void 0 : product.previewImgs) && product.previewImgs.length > 0 ? product.previewImgs.map((img, index)=>{
                        return /*#__PURE__*/ _jsx(Image, {
                            alt: "book-img",
                            src: img.url,
                            width: 788,
                            height: 112
                        }, index);
                    }) : /*#__PURE__*/ _jsx("div", {
                        children: "미리보기 이미지가 없습니다."
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FixedButtonContainer, {
                children: [
                    /*#__PURE__*/ _jsx(FilledButton, {
                        type: "text",
                        variant: "soft",
                        onClick: ()=>{
                            onCancel();
                            router.push(PRODUCTS_PAGE.concat("/".concat(product.id)));
                        },
                        children: "자세히 보기"
                    }),
                    /*#__PURE__*/ _jsx(FilledButton, {
                        type: "text",
                        variant: "solid",
                        onClick: onCancel,
                        children: "확인"
                    })
                ]
            })
        ]
    });
};
const PreviewRelatedItemContainer = styled.div.withConfig({
    componentId: "sc-f1a9a530-2"
})(_templateObject2());
const ProductContainer = styled.div.withConfig({
    componentId: "sc-f1a9a530-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_500);
const ImageContainer = styled.div.withConfig({
    componentId: "sc-f1a9a530-4"
})(_templateObject4());
const FixedButtonContainer = styled.div.withConfig({
    componentId: "sc-f1a9a530-5"
})(_templateObject5());
const StyledDivider = styled(Divider).withConfig({
    componentId: "sc-f1a9a530-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_50);
